export type IconName = 'logoMain' | 'logoPFSvg' | 'chemProbes';

const prices = {
	price1mg: 1,
	price2mg: 2,
	price5mg: 5,
	price10mg: 10,
	price15mg: 15,
	price20mg: 20,
	price25mg: 25,
	price30mg: 30,
	price35mg: 35,
	price40mg: 40,
	price45mg: 45,
	price50mg: 50,
	price75mg: 75
};

export const suppliersConfig: Record<string, { type: string; icon: IconName, url: string, isLink: boolean, className: string }> = {
	EBC: {
		url: '',
		type: 'EBC',
		isLink: false,
		icon: 'logoMain',
		className: 'list-supplier-logo__img-enamine',
	},
	PFIZER: {
		url: '',
		isLink: false,
		type: 'PFIZER',
		icon: 'logoPFSvg',
		className: 'list-supplier-logo__img-pf',
	},
	CHEM_PROBE: {
		isLink: true,
		type: 'CHEM_PROBE',
		icon: 'chemProbes',
		url: 'https://www.chemicalprobes.org/',
		className: 'list-supplier-logo__img-chemical-probes',
	}
};

export default prices;